import { COLORS } from 'helpers/globals'

const dropdown = {
  background: 'white',
  position: 'absolute',
  borderRight: `1px solid ${COLORS.quaternary}`,
  borderLeft: `1px solid ${COLORS.quaternary}`,
  width: ({ onMobile }) => onMobile ? '42%' : 138,
  margin: ({ onMobile }) => onMobile ? '.6rem' : '1px 0 0 0',
  userSelect: 'none',
  padding: '.4rem',
  color: COLORS.primary,
  textAlign: 'left'
}

const container = {
  minHeight: '1.6em',
  paddingLeft: '.2rem',
  width: '100%',
  backgroundColor: COLORS.initial,
  color: COLORS.primary,
  cursor: 'pointer',
  padding: 0,
  userSelect: 'none'
}

export default {
  container,
  mobileContainer: {
    ...container,
    padding: '.5rem',
    color: 'white',
    background: COLORS.primary,
    flex: '1 1 50%',
    borderRadius: '.5rem'
  },
  openDropdown: dropdown,
  closedDropdown: {
    ...dropdown,
    display: 'none'
  },
  option: {
    fontSize: ({ onMobile }) => onMobile ? 'inherit' : '1.4rem',
    '&:hover': {
      color: COLORS.secondary
    }
  },
  caret: {
    marginLeft: ({ onMobile }) => onMobile ? '1rem' : '.5rem',
    fontSize: '2rem',
    color: ({ onMobile }) => onMobile ? 'white' : COLORS.primary
  }
}



// WEBPACK FOOTER //
// ./src/components/PpfPreview/NightModeSelector/style.js